import React from "react";

/** Tiny inline SVG sparkline (values 0-100, null gaps skipped). */
export default function Sparkline({ values = [], width = 96, height = 28, testId }) {
  const pts = values.map((v, i) => [i, v]).filter(([, v]) => v !== null && v !== undefined);
  if (pts.length < 2) return null;
  const n = values.length - 1 || 1;
  const x = (i) => (i / n) * (width - 4) + 2;
  const y = (v) => height - 2 - (v / 100) * (height - 4);
  const d = pts.map(([i, v], k) => `${k ? "L" : "M"}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(" ");
  const last = pts[pts.length - 1];
  const first = pts[0];
  const tone = last[1] > first[1] ? "var(--ok)" : last[1] < first[1] ? "var(--danger)" : "var(--accent)";
  return (
    <svg className="cis-spark" width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true" data-testid={testId}>
      <path d={d} fill="none" stroke={tone} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={x(last[0])} cy={y(last[1])} r="2.6" fill={tone} />
    </svg>
  );
}
